<mat-stepper [linear]="true" #stepper class="w-100" (selectionChange)="onSelectionChangeFn(titles, $event)">
    <mat-step *ngFor="let step of titles; let i = index" [completed]="step.completed" [label]="step.title" [aria-label]="i === nextValidStep ? 'next-valid-step':null" state="phone" >
    </mat-step>
</mat-stepper>